"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectEventResultWithLogo = exports.selectEventResultById = exports.selectLinkedEventResultsByEvent = exports.selectEventResultsTournamentsOptions = exports.selectEventResultsFilterSearch = exports.selectEventResultsFilterDate = exports.selectEventResultsFilterTournamentId = exports.selectEventResultsFilterSportIds = exports.selectEventResultsFilterSportId = exports.selectEventResultsFilterIsLive = exports.selectEventResultsFilterCompletionStatus = exports.selectIsEventListFilterUsed = exports.selectIsEventListEmpty = exports.selectEventResultsList = exports.selectIsEventResultsEventListPolling = exports.selectIsEventResultsEventListLoading = exports.selectIsEventResultsNextPageLoading = exports.selectEventResultsHasNextPage = exports.selectEventResultsNextPageKey = exports.selectEventResultsPage2EventIds = exports.selectIsEventResultsPrevPageLoading = exports.selectEventResultsPrevPageKey = exports.selectEventResultsPage1EventIds = exports.selectEventResultsPage1 = exports.selectHasBeforeEventIds = exports.selectEventResultsBeforePageEventIds = exports.selectEventResultsPage2Number = exports.selectEventResultsPage1Number = exports.selectEventResultsListFilters = exports.selectEventResultsListConfig = exports.selectEventResultFetchItem = exports.selectEventResultFetchById = exports.selectLinkedEventResults = exports.selectEventResultsFetchItems = void 0;
const reselect_1 = require("reselect");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const index_1 = require("../../utils/index");
const array_1 = require("../../utils/array");
const selectors_1 = require("../LogosProvider/selectors");
const LogosProvider_1 = require("../LogosProvider");
const slice_1 = require("./slice");
const constants_1 = require("./constants");
const utils_1 = require("./utils");
const selectEventResultsListState = (state) => state.resultsProviderV2.list;
const selectEventResults = (state) => {
    return state.resultsProviderV2.entries || slice_1.initialState.entries;
};
const selectEventResultsFetchItems = (state) => {
    return state.resultsProviderV2.fetchItems;
};
exports.selectEventResultsFetchItems = selectEventResultsFetchItems;
const selectLinkedEventResults = (state) => {
    return state.resultsProviderV2.linkedEvents;
};
exports.selectLinkedEventResults = selectLinkedEventResults;
const selectEventResultFetchById = (state, id) => {
    return selectEventResults(state)[id];
};
exports.selectEventResultFetchById = selectEventResultFetchById;
const selectEventResultFetchItem = (state, id) => {
    var _a;
    return (_a = state.resultsProviderV2.fetchItem[id]) !== null && _a !== void 0 ? _a : index_1.requestInitialState;
};
exports.selectEventResultFetchItem = selectEventResultFetchItem;
const selectEventResultsListConfig = (state) => {
    var _a;
    return (_a = selectEventResultsListState(state).config) !== null && _a !== void 0 ? _a : constants_1.EVENT_RESULTS_LIST_CONFIG;
};
exports.selectEventResultsListConfig = selectEventResultsListConfig;
const selectEventResultsListFilters = (state) => {
    var _a;
    return ((_a = selectEventResultsListState(state).filters) !== null && _a !== void 0 ? _a : constants_1.EVENT_RESULTS_LIST_FILTERS);
};
exports.selectEventResultsListFilters = selectEventResultsListFilters;
const selectEventResultsPage1Number = (state) => {
    return selectEventResultsListState(state).page1Number;
};
exports.selectEventResultsPage1Number = selectEventResultsPage1Number;
const selectEventResultsPage2Number = (state) => {
    return selectEventResultsListState(state).page2Number;
};
exports.selectEventResultsPage2Number = selectEventResultsPage2Number;
const selectEventResultsBeforePage = (state) => {
    return selectEventResultsListState(state).before;
};
const selectEventResultsBeforePageEventIds = (state) => {
    return selectEventResultsBeforePage(state).eventResultsIds;
};
exports.selectEventResultsBeforePageEventIds = selectEventResultsBeforePageEventIds;
const selectHasBeforeEventIds = (state) => {
    return (0, exports.selectEventResultsBeforePageEventIds)(state).length > 0;
};
exports.selectHasBeforeEventIds = selectHasBeforeEventIds;
const selectEventResultsPage1 = (state) => {
    return selectEventResultsListState(state).page1;
};
exports.selectEventResultsPage1 = selectEventResultsPage1;
const selectEventResultsPage1EventIds = (state) => {
    return (0, exports.selectEventResultsPage1)(state).eventResultsIds;
};
exports.selectEventResultsPage1EventIds = selectEventResultsPage1EventIds;
const selectEventResultsPrevPageKey = (state) => {
    return (0, exports.selectEventResultsPage1)(state).paginationKeyBackward;
};
exports.selectEventResultsPrevPageKey = selectEventResultsPrevPageKey;
const selectIsEventResultsPrevPageLoading = (state) => {
    return !!(0, exports.selectEventResultsPage1)(state).loading;
};
exports.selectIsEventResultsPrevPageLoading = selectIsEventResultsPrevPageLoading;
const selectIsEventResultsPrevPagePolling = (state) => {
    return !!(0, exports.selectEventResultsPage1)(state).polling;
};
const selectEventResultsPage2 = (state) => {
    return selectEventResultsListState(state).page2;
};
const selectEventResultsPage2EventIds = (state) => {
    return selectEventResultsPage2(state).eventResultsIds;
};
exports.selectEventResultsPage2EventIds = selectEventResultsPage2EventIds;
const selectEventResultsNextPageKey = (state) => {
    return (0, exports.selectEventResultsPage1)(state).paginationKeyForward;
};
exports.selectEventResultsNextPageKey = selectEventResultsNextPageKey;
const selectEventResultsHasNextPage = (state) => {
    return !!(0, exports.selectEventResultsNextPageKey)(state);
};
exports.selectEventResultsHasNextPage = selectEventResultsHasNextPage;
const selectIsEventResultsNextPageLoading = (state) => {
    return !!selectEventResultsPage2(state).loading;
};
exports.selectIsEventResultsNextPageLoading = selectIsEventResultsNextPageLoading;
const selectEventIsResultsNextPagePolling = (state) => {
    return !!selectEventResultsPage2(state).polling;
};
const selectIsEventResultsEventListLoading = (state) => {
    return ((0, exports.selectIsEventResultsPrevPageLoading)(state) ||
        (0, exports.selectIsEventResultsNextPageLoading)(state));
};
exports.selectIsEventResultsEventListLoading = selectIsEventResultsEventListLoading;
const selectIsEventResultsEventListPolling = (state) => {
    return (selectIsEventResultsPrevPagePolling(state) ||
        selectEventIsResultsNextPagePolling(state));
};
exports.selectIsEventResultsEventListPolling = selectIsEventResultsEventListPolling;
const selectEventResultsEventsIds = (0, reselect_1.createSelector)([
    exports.selectEventResultsBeforePageEventIds,
    exports.selectEventResultsPage1EventIds,
    exports.selectEventResultsPage2EventIds,
], (beforeEventIds, eventsIds1, eventsIds2) => {
    return [...beforeEventIds, ...eventsIds1, ...eventsIds2];
});
exports.selectEventResultsList = (0, reselect_1.createSelector)([selectEventResultsEventsIds, selectEventResults], (eventsIds, events) => {
    return (0, index_1.getValues)(eventsIds, events);
});
exports.selectIsEventListEmpty = (0, reselect_1.createSelector)([selectEventResults], (events) => {
    return (0, isEmpty_1.default)(events);
});
exports.selectIsEventListFilterUsed = (0, reselect_1.createSelector)([exports.selectEventResultsListFilters], (filters) => {
    return !(0, react_fast_compare_1.default)(filters, constants_1.EVENT_RESULTS_LIST_FILTERS);
});
exports.selectEventResultsFilterCompletionStatus = (0, reselect_1.createSelector)([exports.selectEventResultsListFilters], (filters) => {
    return filters.completionStatus;
});
exports.selectEventResultsFilterIsLive = (0, reselect_1.createSelector)([exports.selectEventResultsListFilters], (filters) => {
    return filters.completionStatus === betweb_openapi_axios_1.CompletionStatus.Live;
});
exports.selectEventResultsFilterSportId = (0, reselect_1.createSelector)([exports.selectEventResultsListFilters], (filters) => {
    var _a;
    return (_a = filters.sportIds) === null || _a === void 0 ? void 0 : _a[0];
});
const selectEventResultsFilterSportIds = (state) => {
    return (0, exports.selectEventResultsListFilters)(state).sportIds;
};
exports.selectEventResultsFilterSportIds = selectEventResultsFilterSportIds;
exports.selectEventResultsFilterTournamentId = (0, reselect_1.createSelector)([exports.selectEventResultsListFilters], (filters) => {
    var _a;
    return (_a = filters.tournamentIds) === null || _a === void 0 ? void 0 : _a[0];
});
exports.selectEventResultsFilterDate = (0, reselect_1.createSelector)([exports.selectEventResultsListFilters], (filters) => {
    const dateString = filters.scheduledFrom || filters.scheduledTo;
    return (0, utils_1.createStartDate)(dateString) || new Date();
});
exports.selectEventResultsFilterSearch = (0, reselect_1.createSelector)([exports.selectEventResultsListFilters], (filters) => {
    return filters.searchQuery || '';
});
exports.selectEventResultsTournamentsOptions = (0, reselect_1.createSelector)(exports.selectEventResultsList, (eventResults) => {
    const r = {};
    for (const eventResult of eventResults) {
        const { tournament } = eventResult;
        if (r[tournament.id] === undefined) {
            r[tournament.id] = {
                value: tournament.id.toString(),
                label: tournament.name,
                isLive: eventResult.completionStatus === betweb_openapi_axios_1.CompletionStatus.Live,
            };
        }
        else {
            r[tournament.id].isLive =
                r[tournament.id].isLive ||
                    eventResult.completionStatus === betweb_openapi_axios_1.CompletionStatus.Live;
        }
    }
    return Object.values(r);
});
exports.selectLinkedEventResultsByEvent = (0, reselect_1.createSelector)([
    exports.selectLinkedEventResults,
    (_, eventResult) => eventResult,
], (linkedEventResults, eventResult) => {
    if (!eventResult.linkedEvents) {
        return array_1.EMPTY_ARRAY;
    }
    return eventResult.linkedEvents
        .map((linkedEvent) => linkedEventResults[linkedEvent.eventId])
        .filter(Boolean);
});
const selectEventResultById = (state, eventId) => {
    return selectEventResults(state)[eventId];
};
exports.selectEventResultById = selectEventResultById;
exports.selectEventResultWithLogo = (0, reselect_1.createSelector)([exports.selectEventResultById, (state) => (0, selectors_1.getCompetitorLogos)(state)], (event, logos) => {
    return (0, LogosProvider_1.enrichEvent)(event, logos);
});
//# sourceMappingURL=selectors.js.map